<section class="layout">
    <app-new-sidebar *ngIf="showSidebar"></app-new-sidebar>
    <loading></loading>
    <div class="main-content">
        <!-- Header -->
        <div>
            <app-new-header><router-outlet></router-outlet></app-new-header>
        </div>
        
    </div>
    
</section>
